import { render, staticRenderFns } from "./ProgramsSearch.vue?vue&type=template&id=5a8ce1fc&lang=pug&"
import script from "./ProgramsSearch.vue?vue&type=script&lang=js&"
export * from "./ProgramsSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports